import React, { useState } from "react";
import axios from "axios";
import "./addCategory.css";

const AddCategory = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState(""); // State to display success or error messages

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("image", image);

    try {
      const response = await axios.post(
        "https://api.swasthmitra.com/api/category/add",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMessage(response.data.message); // Display success message
      // Reset form fields
      setName("");
      setDescription("");
      setImage(null);
      e.target.reset(); // Clear the file input
    } catch (err) {
      setMessage("Error adding category");
      console.error("Error:", err);
    }
  };

  return (
    <div className="add-category-container">
      <h2>Add Category</h2>
      {message && (
        <p
          style={{
            color: message.includes("Error") ? "red" : "green",
            textAlign: "center",
          }}
        >
          {message}
        </p>
      )}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Category Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          placeholder="Category Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
        <input type="file" onChange={handleFileChange} required />
        <button type="submit">Add Category</button>
      </form>
    </div>
  );
};

export default AddCategory;
